export default __webpack_public_path__ + "static/media/flag-saba-island.071a9207.svg";